import _implicitStylesheets from "./dependencyModal.css";

import _implicitScopedStylesheets from "./dependencyModal.scoped.css?scoped=true";

import _myCustomDataTable from "my/customDataTable";
import _lightningButton from "lightning/button";
import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {gid: api_scoped_id, t: api_text, h: api_element, d: api_dynamic_text, b: api_bind, c: api_custom_element} = $api;
  const {_m0, _m1, _m2} = $ctx;
  return [api_element("div", {
    key: 0
  }, [api_element("section", {
    classMap: {
      "slds-modal": true,
      "slds-fade-in-open": true,
      "modal-height__align": true
    },
    attrs: {
      "role": "dialog",
      "tabindex": "-1",
      "aria-labelledby": api_scoped_id("modal-heading-02"),
      "aria-modal": "true",
      "aria-describedby": api_scoped_id("modal-content-id-2")
    },
    key: 1
  }, [api_element("div", {
    classMap: {
      "slds-modal__container": true,
      "dep-modal_align": true
    },
    key: 2
  }, [api_element("header", {
    classMap: {
      "slds-modal__header": true,
      "modal-title_top": true
    },
    key: 3
  }, [api_element("h2", {
    classMap: {
      "slds-modal__title": true,
      "slds-hyphenate": true,
      "header-title_align": true
    },
    attrs: {
      "id": api_scoped_id("modal-heading-02"),
      "data-my-id": "dependenciesHeader"
    },
    key: 4
  }, [api_text("Dependencies")]), api_element("br", {
    key: 5
  }, [])]), api_element("div", {
    classMap: {
      "slds-modal__content": true,
      "slds-p-around_medium": true,
      "modal-pos_height": true
    },
    attrs: {
      "id": api_scoped_id("modal-content-id-2")
    },
    key: 6
  }, [api_element("h3", {
    classMap: {
      "header-text_align": true
    },
    key: 7
  }, [api_text("The following items are required for "), api_element("span", {
    classMap: {
      "name-text_align": true
    },
    key: 8
  }, [api_text(api_dynamic_text($cmp.name))]), api_text(" (" + api_dynamic_text($cmp.developerName) + ")")]), api_element("h3", {
    classMap: {
      "sel-items-text_align": true
    },
    key: 9
  }, [api_text("Select the items to include in this deployment.")]), api_element("div", {
    classMap: {
      "data-table__align": true
    },
    key: 10
  }, [api_custom_element("my-custom-data-table", _myCustomDataTable, {
    classMap: {
      "modal-datatable__align": true
    },
    props: {
      "keyField": "id",
      "data": $cmp.data,
      "columns": $cmp.columns,
      "selectedRows": $cmp.preSelectedDepRows
    },
    key: 11,
    on: {
      "rowselection": _m0 || ($ctx._m0 = api_bind($cmp.getSelectedName))
    }
  }, [])])]), api_element("footer", {
    classMap: {
      "slds-modal__footer": true,
      "modal-fotter_align": true
    },
    key: 12
  }, [api_element("div", {
    key: 13
  }, [api_custom_element("lightning-button", _lightningButton, {
    classMap: {
      "fotter-btn_align": true
    },
    props: {
      "label": "Cancel",
      "variant": "neutral",
      "title": "Cancel"
    },
    key: 14,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.closeModal))
    }
  }, []), api_custom_element("lightning-button", _lightningButton, {
    classMap: {
      "fotter-btn_align": true
    },
    props: {
      "label": "Add Selected",
      "variant": "brand",
      "title": "Add Selected"
    },
    key: 15,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.addSelectedDependencies))
    }
  }, [])])])])]), api_element("div", {
    classMap: {
      "slds-backdrop": true,
      "slds-backdrop_open": true
    },
    key: 16
  }, [])])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "my-dependencyModal_dependencyModal"
